import Cookies from 'js-cookie';
import { message } from 'antd';
import { TOKEN_NAME } from '../constants';

// Opens the admin/operator guide, which is served by the backend behind
// an ADMIN/USER roles guard (so partner viewers / anonymous users can't
// reach it). The JWT lives in a Bearer header — a plain browser
// navigation can't send that — so we fetch the HTML with the token,
// inject the current app language + origin, and open it as a blob in a
// new tab.
//
// `lang` is the reader's current app language ('fr' | 'en'); it's
// injected as window.__OVO_GUIDE_LANG__ so the guide boots in that
// language even though the blob URL carries no query string.
export async function openAdminGuide(lang) {
  const safeLang = lang === 'fr' ? 'fr' : 'en';
  // Open the tab synchronously, inside the click handler, so it isn't
  // blocked as a pop-up; we navigate it to the blob once it's ready.
  // NB: do NOT pass "noopener" here — that makes window.open() return
  // null, so we'd be unable to fill the tab and it would stay blank.
  const win = window.open('', '_blank');
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URI}/docs/admin-guide`, {
      headers: { Authorization: `Bearer ${Cookies.get(TOKEN_NAME)}` },
    });
    if (!res.ok) throw new Error(`status ${res.status}`);
    let html = await res.text();
    const inject =
      `<script>window.__OVO_GUIDE_LANG__=${JSON.stringify(safeLang)};` +
      `window.__OVO_APP_ORIGIN__=${JSON.stringify(window.location.origin)};</script>`;
    html = html.includes('</head>') ? html.replace('</head>', `${inject}</head>`) : inject + html;
    const url = URL.createObjectURL(new Blob([html], { type: 'text/html' }));
    if (win) {
      win.location.href = url;
    } else {
      // Pop-up was blocked — fall back to navigating the current tab.
      window.location.href = url;
    }
    // Best-effort cleanup; the tab keeps its own reference to the blob.
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (e) {
    if (win) win.close();
    message.error('The guide is only available to operators and admins.');
  }
}
